module.exports = __webpack_public_path__ + "img/thumbslider.f29eb192.jpg";